import { useQuery } from "@tanstack/react-query"
import { getTrackStats } from "../../../api/releaseStats"

export function TrackStatsModal({upc,previewTitle}) {
    const {data: releaseTracks, isLoading: boolean} = useQuery({
        queryKey: ["track_stats", upc],
        queryFn: async () => await getTrackStats(upc),
    })
    return (
        <div className="modal fade" id="tracksModal" tabindex="-1" aria-labelledby="tracksModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header">
                      <div className="modal-top">
                          <h5>{previewTitle} Tracks</h5>
                          <i className="fi fi-rr-cross" data-bs-dismiss="modal"></i>
                      </div>
                  </div>
                  <div className="modal-body">
                    <div className="table-responsive mt-3">
                        <table className="table dash-table">
                            <thead>
                                <tr>
                                    <td>Track Title</td>
                                    <td>Streams</td>
                                    <td>Revenue</td>
                                </tr>
                            </thead>
                            <tbody>
                              {
                                releaseTracks && releaseTracks.map((track, i) => (
                                  <tr key={i}>
                                      <td>
                                          <div className="table-item">
                                              {track.title}
                                          </div>
                                      </td>
                                      <td>
                                          <div className="table-item">
                                              {track.streams}
                                          </div>
                                      </td>
                                      <td>
                                          <div className="table-item">
                                              ${(track.revenue * 1).toFixed(2)} 
                                              {
                                                track.share !== 100 && <span className='track-split-text'>({track.share}% Split)</span>
                                              }
                                          </div>
                                      </td>
                                  </tr>
                                ))
                              }
                            </tbody>
                        </table>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    )
}